import React from "react";
import Layout from "../../components/layout";
import { Col, Form, Input, Row, Button, Card } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { showLoading, hideLoading } from "../../redux/alertsSlice";

function Speciality() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      //post request to register user
      dispatch(showLoading());
      const response = await axios.post(
        "/api/admin/speciality",
        { ...values, userId: user._id },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      dispatch(hideLoading());
      if (response.data.success) {
        //toast message
        toast.success(response.data.message);
        navigate("/");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(hideLoading());
      toast.error("Something went wrong");
    }
  };

 return (
  <Layout>
    <Card title="Add Specialization Details" bordered style={{ maxWidth: 600, margin: "0 auto" }}>
      <Form layout="vertical" className="formFactor" onFinish={onFinish}>
        <Row gutter={20}>
          <Col span={8} xs={24} sm={24} lg={24}>
            <Form.Item
              required
              label="Specialization"
              name="speciality"
              rules={[{ required: true, message: "Speciality is required" }]}
            >
              <Input placeholder="Specialization" />
            </Form.Item>
          </Col>
        </Row>
        <div className="d-flex justify-content-end">
          <Button type="primary" className="btn-primary" htmlType="submit">
            SUBMIT
          </Button>
        </div>
      </Form>
    </Card>
  </Layout>
);
}
export default Speciality;
